import { hot } from 'react-hot-loader/root'
import React, { Component } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import AdminUsersPage from 'dashboard/users/AdminUsersPage';
import AdminSellersPage from 'dashboard/sellers/AdminSellersPage';
import AdminContractorsPage from 'dashboard/contractors/AdminContractorsPage';
import { connect } from 'react-redux';
import AdminProductsPage from 'dashboard/products/AdminProductsPage';
import AdminCategoriesPage from 'dashboard/products/AdminCategoriesPage';
import AdminQualityChecksPage from 'dashboard/qualityChecks/AdminQualityChecksPage';
import config from '../../config';
import AdminGBGProductsPage from 'dashboard/GBG_products/AdminGBGProductsPage';
import ProductProcessingPage from 'dashboard/processing/ProductProcessingPage';
import('../util/FullStoryScriptDashboard');
import AdminSubscriptionsPage from 'dashboard/Subscriptions/AdminSubscriptionsPage';
import AdminServicesPage from 'dashboard/services/AdminServicesPage';
import AdminUserTimeTrackingPage from 'dashboard/userData/AdminUserTimeTrackingPage';
import AdminSettingsPage from 'dashboard/settings/AdminSettingsPage';

import AdminMetroAreasList from 'dashboard/metroAreas/AdminMetroAreasList';
import TransactionsPage from 'dashboard/transactions/TransactionsPage';
import PromoCodesPage from 'dashboard/promoCodes/AdminPromoCodesPage';
import Orders from 'dashboard/orders/AdminOrdersPage';
import AdminPalletsPage from 'dashboard/pallets/AdminPalletsPage';
import AdminReportsPage from 'dashboard/reports/AdminReportsPage';
import EmailPage from 'dashboard/emails/EmailPage';
import ServiceAreasSettingsPage from 'dashboard/serviceAreas/ServiceAreasSettingsPage';
import AdminFulfillmentPage from "./fulfillment/AdminFulfillmentPage";
import AdminInventoryReconPage from "./inventoryRecon/AdminInventoryReconPage";
import InventoryProjectsPage from "./inventoryProjects/InventoryProjectsPage";
import { isUserAllowed } from "../../server/api/settings/featureFlag";
import { base64ToHex } from 'util/Utils'


class AdminPanel extends Component {

  constructor(props, context) {

    super(props, context);
    var defaultTabForUserRole = '/sellers'
    if (_.size(_.intersection(this.props.userReducer.user.Roles, ['Wingmom', 'AMT Team'])) > 0 && _.size(_.intersection(this.props.userReducer.user.Roles, ['Ops Manager', 'Product Manager', 'Administrator'])) == 0) {
      defaultTabForUserRole = '/reports'
    }
    var defaultTab = this.props.location.pathname.substring(this.props.location.pathname.lastIndexOf('/admin') + 6) || defaultTabForUserRole;
    if (this.props.location.pathname.includes('/services/add')) {
      defaultTab = '/services'
    }
    if (defaultTab == '/time-tracking-registry') {
      defaultTab = '/time-tracking'
    }
    if (_.size(_.intersection(this.props.userReducer.user.Roles, ['Partner'])) > 0) {
      defaultTab = '/products'
    }
    this.state = {
      defaultTab: defaultTab
    };

  };
  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired,
    };
  }


  render() {
    var self = this;
    function handleSelect(key) {
      self.context.router.push('/admin' + key);
    };

    const isInboundEnabled = isUserAllowed(
      { Data: this.props.appData.FeatureFlags },
      "EnableInboundFlow",
      base64ToHex(this.props.userReducer.user._id, { convertToHEXUUID: true }).toLowerCase())

    return (
      <div>
        <Tabs defaultActiveKey={this.state.defaultTab} onSelect={handleSelect} id="admin-tabs">
          {/*unmountOnExit - do not render component until the tab is clicked*/}
          {config.checkAccessRights.call(self, { resources: ['products_view'] }) &&
            <Tab eventKey={'/products'} unmountOnExit={true} title="Products">
              <AdminProductsPage location={this.props.location}></AdminProductsPage>
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['users_view'] }) &&
            <Tab eventKey={'/users'} unmountOnExit={true} title="Users">
              <AdminUsersPage location={this.props.location}></AdminUsersPage>
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['sellers_view'] }) &&
            <Tab eventKey={'/sellers'} unmountOnExit={true} title="Sellers">
              <AdminSellersPage location={this.props.location}></AdminSellersPage>
            </Tab>
          }

          {config.checkAccessRights.call(self, { resources: ['contractors_edit'] }) &&
            <Tab eventKey={'/contractors'} unmountOnExit={true} title="Workers">
              <AdminContractorsPage location={this.props.location}></AdminContractorsPage>
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['categories_edit'] }) &&
            <Tab eventKey={'/categories'} unmountOnExit={true} title="Categories">
              <AdminCategoriesPage />
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['GBG_products_edit'] }) &&
            <Tab eventKey={'/gbg-products'} unmountOnExit={true} title="GBG Products">
              <AdminGBGProductsPage location={this.props.location} />
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['subscriptions_edit'] }) &&
            <Tab eventKey={'/subscriptions'} unmountOnExit={true} title="Subscriptions">
              <AdminSubscriptionsPage location={this.props.location} />
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['metro_areas_edit'] }) &&
            <Tab eventKey={'/metro-areas'} unmountOnExit={true} title="Metro areas">
              <AdminMetroAreasList />
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['services_edit'] }) &&
            <Tab eventKey={'/services'} unmountOnExit={true} title="Services">
              <AdminServicesPage location={this.props.location} />
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['services_areas_edit'] }) &&
            <Tab eventKey={'/service-areas'} unmountOnExit={true} title="Service Areas">
              <ServiceAreasSettingsPage location={this.props.location} />
            </Tab>
          }
          {(config.checkAccessRights.call(self, { resources: ['time_tracking_view'] }) || (_.get(this.props, ['userReducer', 'contractor', '_id'], false) && _.get(this.props, ['userReducer', 'contractor', 'Status']) == 'Active')) &&
            <Tab eventKey={'/time-tracking'} unmountOnExit={true} title="Time tracking">

              <AdminUserTimeTrackingPage location={this.props.location} />
            </Tab>
          }

          {config.checkAccessRights.call(self, { resources: ['orders_view'] }) &&
            <Tab eventKey={'/orders'} unmountOnExit={true} title="Orders">
              <Orders location={this.props.location}></Orders>
            </Tab>
          }

          {config.checkAccessRights.call(self, { resources: ['pallets_edit'] }) &&
            <Tab eventKey={'/pallets'} unmountOnExit={true} title="Pallets">
              <AdminPalletsPage location={this.props.location}></AdminPalletsPage>
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['payout_registry_view'] }) &&
            <Tab eventKey={'/payout-registry'} unmountOnExit={true} title="Payout Registry">
              <TransactionsPage location={this.props.location}></TransactionsPage>
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['contractors_reports_view', 'KPI_reports_view', 'AMT_page'] }) &&
            <Tab eventKey={'/reports'} unmountOnExit={true} title="Reports">
              <AdminReportsPage location={this.props.location}></AdminReportsPage>
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['emails_edit'] }) &&
            <Tab eventKey={'/emails'} unmountOnExit={true} title="Emails">
              <EmailPage location={this.props.location}></EmailPage>
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['promo_codes_edit'] }) &&
            <Tab eventKey={'/promo-codes'} unmountOnExit={true} title="Promo Codes">
              <PromoCodesPage location={this.props.location}></PromoCodesPage>
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['settings_edit'] }) &&
            <Tab eventKey={'/settings'} unmountOnExit={true} title="Settings">
              <AdminSettingsPage location={this.props.location}></AdminSettingsPage>
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['quality_checks_edit'] }) &&
            <Tab eventKey={'/quality-checks'} unmountOnExit={true} title="Quality Checks">
              <AdminQualityChecksPage location={this.props.location}></AdminQualityChecksPage>
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['fulfillment_edit'] }) &&
            <Tab eventKey={'/fulfillment'} unmountOnExit={true} title="Fulfillment">
              <AdminFulfillmentPage location={this.props.location}></AdminFulfillmentPage>
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['inventory_recon_view'] }) &&
            <Tab eventKey={'/inventory-recon'} unmountOnExit={true} title="Inventory Recon">
              <AdminInventoryReconPage location={this.props.location}></AdminInventoryReconPage>
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['processing_3PL'] }) &&
            isInboundEnabled &&
            <Tab eventKey={'/processing-3PL'} unmountOnExit={true} title="Processing-3PL">
              <ProductProcessingPage location={this.props.location}></ProductProcessingPage>
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['processing_seller'] }) &&
            isInboundEnabled &&
            <Tab eventKey={'/processing-seller'} unmountOnExit={true} title="Processing-Seller">
              <ProductProcessingPage location={this.props.location}></ProductProcessingPage>
            </Tab>
          }

          {config.checkAccessRights.call(self, { resources: ['processing_3PL_manager'] }) &&
            isInboundEnabled &&
            <Tab eventKey={'/processing-3PL-manager'} unmountOnExit={true} title="Processing-3PL Manager">

              <ProductProcessingPage location={this.props.location}></ProductProcessingPage>
            </Tab>
          }
          {config.checkAccessRights.call(self, { resources: ['inventory_projects_edit'] }) &&
            <Tab eventKey={'/inventory-projects'} unmountOnExit={true} title="Inventory">
              <InventoryProjectsPage location={this.props.location}></InventoryProjectsPage>
            </Tab>
          }

          {config.checkAccessRights.call(self, { resources: ['inboundRebound'] }) &&
            <Tab eventKey={'/inboundRebound'} unmountOnExit={true} title="Inbound Rebound">
              <ProductProcessingPage location={this.props.location}></ProductProcessingPage>
            </Tab>
          }

        </Tabs>

      </div >
    );

  }
}
function mapStateToProps(state, props) {
  return {
    userReducer: state.userReducer,
    appData: state.appData,
  };
}

export default connect(mapStateToProps, {})(hot(AdminPanel));